const state = {
    doctor: false,
    selectedDepList: sessionStorage.getItem('selectedDepList') ? JSON.parse(sessionStorage.getItem('selectedDepList')) : [], // 选中科室
    selectedDoctor: sessionStorage.getItem('selectedDoctor') ? JSON.parse(sessionStorage.getItem('selectedDoctor')) : {}, // 选中的医生
    selectedCard: {},
    goldDorDistrictListSave: []
};

const mutations = {
    setDoctor(state, str) {
        state.doctor = str
    },
    setSelectedDepList(state, str) {
        state.selectedDepList = str
    },
    setSelectedDoctor(state, str) {
        state.selectedDoctor = str
    },
    setSelectedCard(state, str) {
        state.selectedCard = str
    },
    setGoldDorDistrictListSave(state, str) {
        state.goldDorDistrictListSave = str
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};